import { Close } from '@mui/icons-material';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@mui/material';

import './TermsModal.scss';

export type TermsModalProps = {
  open: boolean;
  onClose: () => void;
};

export const TermsModal: React.FC<TermsModalProps> = ({ open, onClose }) => {
  return (
    <Dialog open={open} className="terms-modal" onClose={onClose}>
      <DialogActions
        color="primary"
        className="dialog-actions d-flex justify-content-between w-100"
      >
        <DialogTitle color="primary" className="h5 p-2">
          Terms and Conditions
        </DialogTitle>
        <IconButton color="primary" className="close-btn" onClick={onClose}>
          <Close color="inherit" />
        </IconButton>
      </DialogActions>

      <DialogContent className="d-flex flex-column">
        <span className="mb-3">
          Please read these terms and conditions ("terms and conditions",
          "terms") carefully before using www.getinspectsmart.com website
          (‘‘site’’,“website”) and <b>Inspectsmart</b> Web App
          (“App”,”service”,”Application’’) operated by{' '}
          <b>M/s. Fieldmate Pvt Ltd</b>
          ("us", 'we", "our").
        </span>
        <span className="h6 mb-3 font-bold">
          1. Accounts [User Registration]
        </span>
        <span className="mb-3">
          The information provided on our Site/App is not intended for
          distribution to or use by any person or entity in any jurisdiction or
          country where such distribution or use would be contrary to law or
          regulation or which would subject us to any registration requirement
          within such jurisdiction or country. Accordingly, those persons who
          choose to access the Site/App from other locations do so on their own
          initiative and are solely responsible for compliance with local laws,
          if and to the extent local laws are applicable. <br />
          <br />
          You may be required to register with the Site/App. You agree to keep
          your password confidential and will be responsible for all use of your
          account and password. We reserve the right to remove, reclaim, or
          change a username you select if we determine, in our sole discretion,
          that such username is inappropriate, obscene, or otherwise
          objectionable.
          <br />
          <br /> The Site/App is intended for users who are at least 18 years
          old. Persons under the age of 18 are not permitted to use or register
          for the Site/App. <br />
          <br />
          By using the Site/App, you represent and warrant that: (1) all
          registration information you submit will be true, accurate, current,
          and complete; (2) you will maintain the accuracy of such information
          and promptly update such registration information as necessary; (3)
          you have the legal capacity and you agree to comply with these Terms;
          (4) you are not a minor in the jurisdiction in which you reside; (5)
          you will not access the Site/App through automated or non-human means,
          whether through a bot, script or otherwise; (6) you will not use the
          Site/App for any illegal or unauthorized purpose; and (7) your use of
          the Site will not violate any applicable law or regulation. <br />
          <br />
          If you provide any information that is untrue, inaccurate, not
          current, or incomplete, we have the right to suspend or terminate your
          account and refuse any and all current or future use of the Site/App
          (or any portion thereof)
        </span>
        <span className="h6 mb-3 font-bold">2. Links to Other Content</span>
        <span className="mb-3">
          Our Service may contain links to third-party web sites or services
          that are not owned or controlled by the Company.
          <br /> <br />
          The Company has no control over, and assumes no responsibility for,
          the content, privacy policies, or practices of any third party web
          sites or services. You further acknowledge and agree that the Company
          shall not be responsible or liable, directly or indirectly, for any
          damage or loss caused or alleged to be caused by or in connection with
          the use of or reliance on any such content, goods or services
          available on or through any such web sites or services.
          <br /> <br />
          We strongly advise You to read the terms and conditions and privacy
          policies of any third-party web sites or services that You visit.
        </span>
        <span className="h6 mb-3 font-bold">3. User Content</span>
        <span className="mb-3">
          The Applications and Services allow you to submit user-generated
          content (User Content) and also allow you to communicate that content
          to your selected recipients (if any). We do not control User Content
          submitted. You are solely responsible for User Content as submitted by
          you.
          <br />
          <br />
          User Content must not:
          <br />
          <br />
          <ul>
            <li>
              contain or link to any material which infringes any intellectual
              property right or other right of any other person;
            </li>
            <li>
              be made in breach of any legal duty owed to a third party, such as
              a contractual duty or a duty of confidence or data protection
              obligations;
            </li>
            <li>
              contain or link to any material which is defamatory of any person
              or entity;
            </li>
            <li>be likely to mislead or deceive any person;</li>
            <li>
              be used to impersonate any person, or to misrepresent your
              identity or affiliation with any person;
            </li>
            <li>
              contain or link to any material which is obscene, offensive,
              hateful or inflammatory;
            </li>
            <li>
              be menacing, threatening, abuse or invade another's privacy, or
              cause harassment, anxiety, alarm, upset, embarrassment, annoyance
              or inconvenience to any person;
            </li>
            <li>contain, link to or promote sexually explicit material;</li>
            <li>promote violence or aggression;</li>
            <li>
              promote discrimination based on race, gender, religion,
              nationality, disability, sexual orientation or age;
            </li>
            <li>
              encourage, advocate, promote, solicit, invite or assist any
              illegal activity or unlawful act such as (by way of example only)
              intellectual property infringement or computer misuse;
            </li>
            <li>
              be used to transmit, or procure the sending of, any unsolicited or
              unauthorised advertising or promotional material or any other form
              of similar solicitation (spam); contain or link to any viruses,
              Trojan horses, worms, time-bombs, keystroke loggers, spyware,
              adware or any other harmful programs or similar computer code
              designed to adversely affect the operation of any computer
              software or hardware;
            </li>
            <li>
              or give the impression that it emanates from us, our licensors,
              partners or associated organisations, if this is not the case.
            </li>
          </ul>
          You agree that, by submitting any User Content, you grant us and our
          affiliates a perpetual, irrevocable, worldwide, non-exclusive,
          royalty-free and fully sub-licensable right and licence to use,
          reproduce, modify, publish, translate, distribute, perform and display
          such User Content (in whole or part) to the extent necessary in order
          for us to provide the Services.
          <br />
          <br />
          Whilst we do not pre-screen User Content, we reserve the right, in our
          sole discretion, to delete, edit or modify any User Content submitted
          by you, at any time without prior notice, if we need to do so for
          security, legal or, unless that content is part of a subscription you
          have paid for, any other reasons.
        </span>
        <span className="h6 mb-3 font-bold">4. Content Backups</span>
        <span className="mb-3">
          Although regular backups of Content are performed, the Company does
          not guarantee there will be no loss or corruption of data.
          <br />
          <br />
          Corrupt or invalid backup points may be caused by, without limitation,
          Content that is corrupted prior to being backed up or that changes
          during the time a backup is performed.
          <br />
          <br />
          The Company will provide support and attempt to troubleshoot any known
          or discovered issues that may affect the backups of Content. But You
          acknowledge that the Company has no liability related to the integrity
          of Content or the failure to successfully restore Content to a usable
          state.
          <br />
          <br />
          You agree to maintain a complete and accurate copy of any Content in a
          location independent of the Service.
        </span>
        <span className="h6 mb-3 font-bold">
          5. Intellectual Property Rights
        </span>
        <span className="mb-3">
          We license, but do not sell, to you any Application you access or use.
          We remain the owners of all Applications at all times.
          <br />
          <br />
          All intellectual property rights in the Applications and Services of
          their content (including text, graphics, software, photographs and
          other images, videos, sound, trademarks and logos), other than User
          Content, are owned by us or our licensors. Except as expressly set out
          here, nothing in these terms and conditions gives you any rights in
          respect of any intellectual property owned by us or our licensors and
          you acknowledge that you do not acquire any ownership rights by
          accessing any Application or any content from any Application.
          <br />
          <br />
          The Applications may contain code, commonly referred to as open source
          software, which is distributed under any of the many known variations
          of open source licence terms, including terms which allow the free
          distribution and modification of the relevant software’s source code
          and/or which require all distributors to make such source code freely
          available upon request, including any contributions or modifications
          made by such distributor (collectively, Open Source Software). Please
          note that, to the extent that any Application contains any Open Source
          Software, you are only permitted to use that element under the
          relevant licence terms of the applicable third party licensor (Open
          Source Licence Terms) and not under these terms and conditions, and
          you accept and agree to be bound by such Open Source Licence Terms.
        </span>
        <span className="h6 mb-3 font-bold">6. GDPR Privacy Policy</span>
        <span className="mb-3">
          Legal Basis for Processing Personal Data under GDPR:-
          <br />
          <br />
          We may process Personal Data under the following conditions:
          <br />
          <br />
          <ul>
            <li>
              <b>Consent: </b>You have given Your consent for processing
              Personal Data for one or more specific purposes.
            </li>
            <li>
              <b>Performance of a contract:</b> Provision of Personal Data is
              necessary for the performance of an agreement with You and/or for
              any pre-contractual obligations thereof.
            </li>
            <li>
              <b>Legal obligations:</b> Processing Personal Data is necessary
              for compliance with a legal obligation to which the Company is
              subject.
            </li>
            <li>
              <b>Vital interests:</b> Processing Personal Data is necessary in
              order to protect Your vital interests or of another natural
              person.
            </li>
            <li>
              <b>Public interests:</b> Processing Personal Data is related to a
              task that is carried out in the public interest or in the exercise
              of official authority vested in the Company.
            </li>
            <li>
              <b>Legitimate interests:</b> Processing Personal Data is necessary
              for the purposes of the legitimate interests pursued by the
              Company.
            </li>
          </ul>
          In any case, the Company will gladly help to clarify the specific
          legal basis that applies to the processing, and in particular whether
          the provision of Personal Data is a statutory or contractual
          requirement, or a requirement necessary to enter into a contract.
        </span>
        <span className="h6 mb-3 font-bold">7. Disclaimers</span>
        <span className="mb-3">
          The information contained on the Service is for general information
          purposes only.
          <br />
          <br />
          The Company assumes no responsibility for errors or omissions in the
          contents of the Service.
          <br />
          <br />
          In no event shall the Company be liable for any special, direct,
          indirect, consequential, or incidental damages or any damages
          whatsoever, whether in an action of contract, negligence or other
          tort, arising out of or in connection with the use of the Service or
          the contents of the Service. The Company reserves the right to make
          additions, deletions, or modifications to the contents on the Service
          at any time without prior notice.
          <br />
          <br />
          The Company does not warrant that the Service is free of viruses or
          other harmful components.
        </span>
        <span className="h6 mb-3 font-bold">
          8. Viruses, Malware and Security
        </span>
        <span className="mb-3">
          We exercise all reasonable skill and care to ensure that Our Site/App
          is secure and free from viruses and other malware. You are responsible
          for protecting your hardware, software, data and other material from
          viruses, malware, and other internet security risks.
          <br />
          <br />
          You must not deliberately introduce viruses or other malware, or any
          other material which is malicious or technologically harmful either to
          or via Our Site/App.
          <br />
          <br />
          You must not attempt to gain unauthorized access to any part of our
          Site/App, the server on which Our Site/App is stored, or any other
          server, computer, or database connected to Our Site/App. You must not
          attack Our Site/App by means of a denial of service attack, a
          distributed denial of service attack, or by any other means.
        </span>
        <span className="h6 mb-3 font-bold">9. Privacy and Cookies</span>
        <span className="mb-3">
          Use of your personal information submitted to us (whether via any
          Application, Service or the Website) is governed by our Privacy and
          Cookies Policy. Additionally, by using our any Application or Service,
          you acknowledge that internet transmissions are never completely
          private or secure and that it is always possible that any message or
          information you send using any Application or Service may be read or
          intercepted by others.
        </span>
        <span className="h6 mb-3 font-bold">10. Data Protection</span>
        <span className="mb-3">
          The security of Your Personal Data is important to Us, but remember
          that no method of transmission over the Internet, or method of
          electronic storage is 100% secure. While We strive to use commercially
          acceptable means to protect Your Personal Data, we cannot guarantee
          its absolute security.
        </span>
        <span className="h6 mb-3 font-bold">11. Law and Jurisdiction</span>
        <span className="mb-3">
          Any dispute related in any way to your visit to this website or to Web
          App service you purchase from us shall be arbitrated by state or
          federal court <b>[SURAT District- Gujarat, India]</b> and you consent
          to exclusive jurisdiction and venue of the court.
        </span>
        <span className="h6 mb-3 font-bold">
          12. Changes to These Terms and Conditions
        </span>
        <span className="mb-3">
          We reserve the right, at Our sole discretion, to modify or replace
          these Terms at any time. If a revision is material. We will make
          reasonable efforts to provide at least 30 days' notice prior to any
          new terms taking effect. What constitutes a material change will be
          determined at Our sole discretion.
          <br />
          <br />
          By continuing to access or use our service after those revisions
          become effective, you agree to be bound by the revised terms. If you
          do not agree to the new terms, in whole or in part, please stop using
          the website and the web service.
        </span>
        <span className="h6 mb-3 font-bold">13. Termination</span>
        <span className="mb-3">
          We may terminate or suspend your account immediately, without prior
          notice or liability, for any reason whatsoever, including without
          limitation if you breach these Terms and Conditions.
          <br />
          <br />
          Upon termination, your right to use the Service will cease
          immediately. If you wish to terminate your account, you may simply
          discontinue using the Service.
        </span>
        <span className="h6 mb-3 font-bold">14. Limitations on Liability</span>
        <span className="mb-3">
          <b>M/s. Fieldmate Pvt Ltd</b> is not liable for any damages that may
          occur to you as a result of your misuse of our website/App.
          <br />
          <br />
          <b>M/s. Fieldmate Pvt Ltd.</b>reserves the right to edit, modify, and
          change this Agreement at any time. We shall let our users know of
          these changes through electronic mail. This Agreement is an
          understanding between <b>M/s. Fieldmate Pvt Ltd.</b> and the user, and
          this supersedes and replaces all prior agreements regarding the use of
          this website/App.
        </span>
        <span className="h6 mb-3 font-bold">15. Contacting Us</span>
        <span>
          If you have any questions about these policies, you can contact us:
          <br />
          <br />
          <ul>
            <li>
              By visiting this page on our website:{' '}
              <a
                href="www.getinspectsmart.com"
                rel="noreferrer"
                target="_blank"
              >
                www.getinspectsmart.com
              </a>
            </li>
            <li>
              By sending us an email:
              <a
                target="_blank"
                rel="noreferrer"
                href="https://mail.google.com/mail/?view=cm&to=support@getinspectsmart.com&fs=1"
              >
                support@getinspectsmart.com
              </a>
            </li>
          </ul>
        </span>
      </DialogContent>
    </Dialog>
  );
};
